(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[396],{

/***/ 5109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ Layout_Layout; }
});

// EXTERNAL MODULE: ./components/Footer/index.ts + 2 modules
var Footer = __webpack_require__(2689);
// EXTERNAL MODULE: ./components/Navbar/index.ts + 7 modules
var Navbar = __webpack_require__(7430);
// EXTERNAL MODULE: ./node_modules/react-no-ssr/index.js
var react_no_ssr = __webpack_require__(6467);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Layout/Layout.tsx






var Layout = function Layout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "h-full w-full overflow-hidden mx-auto",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_no_ssr["default"], {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar/* Navbar */.w, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* Footer */.$, {})]
  });
};

/* harmony default export */ var Layout_Layout = (Layout);
;// CONCATENATED MODULE: ./components/Layout/index.ts


/***/ }),

/***/ 2575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* reexport */ PageHeader_PageHeader; }
});

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/PageHeader/PageHeader.tsx




var PageHeader = function PageHeader(_ref) {
  var topic = _ref.topic,
      detail = _ref.detail,
      backgroundImage = _ref.backgroundImage;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "relative w-screen h-fit lg:h-[27rem] bg-darkBlue flex justify-center items-center",
    children: [backgroundImage && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute top-0 left-0 inset-0 z-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: backgroundImage,
        alt: "background-image-header",
        width: "100%",
        height: "100%",
        layout: "fill",
        objectFit: "cover"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      id: topic,
      className: "Container relative z-10 mt-20 lg:mt-8 mb-16 lg:mb-0",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: "gradient-head-large w-fit text-dSmallBold leading-[5rem]",
        children: topic
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-white text-p1Medium mt-5",
        children: detail
      })]
    })]
  });
};

/* harmony default export */ var PageHeader_PageHeader = (PageHeader);
;// CONCATENATED MODULE: ./components/PageHeader/index.ts


/***/ }),

/***/ 7180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5109);
/* harmony import */ var _components_PageHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2575);
/* harmony import */ var _components_OldDesign_header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6627);
/* harmony import */ var models_conent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3290);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5893);










var PrivacyPolicyPage = function PrivacyPolicyPage() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_OldDesign_header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      content: {
        title: 'Privacy Policy - นโยบายความเป็นส่วนตัวของ CODIUM',
        content: 'เรียนรู้เกี่ยวกับนโยบายความเป็นส่วนตัวของ CODIUM เราให้ความสำคัญกับการปกป้องข้อมูลส่วนบุคคลของคุณและการใช้งานข้อมูลอย่างปลอดภัย',
        image: null
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_PageHeader__WEBPACK_IMPORTED_MODULE_1__/* .PageHeader */ .m, {
      topic: "\u0E1B\u0E23\u0E30\u0E01\u0E32\u0E28\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27",
      detail: "\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17 \u0E42\u0E04\u0E40\u0E14\u0E35\u0E22\u0E21 \u0E08\u0E33\u0E01\u0E31\u0E14 (\u201C\u0E40\u0E23\u0E32\u201D) \u0E43\u0E2B\u0E49\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E33\u0E04\u0E31\u0E0D\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E04\u0E49\u0E38\u0E21\u0E04\u0E23\u0E2D\u0E07\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E17\u0E48\u0E32\u0E19 \u0E40\u0E23\u0E32\u0E08\u0E36\u0E07\u0E43\u0E2B\u0E49\u0E04\u0E27\u0E32\u0E21\u0E23\u0E31\u0E1A\u0E23\u0E2D\u0E07\u0E27\u0E48\u0E32 \u0E40\u0E23\u0E32\u0E08\u0E30\u0E40\u0E01\u0E47\u0E1A\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21 \u0E43\u0E0A\u0E49 \u0E41\u0E25\u0E30/\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E15\u0E32\u0E21\u0E1B\u0E23\u0E30\u0E01\u0E32\u0E28\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32\u0E15\u0E32\u0E21\u0E17\u0E35\u0E44\u0E14\u0E49 \u0E23\u0E30\u0E1A\u0E38\u0E44\u0E27\u0E49\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19 \u0E42\u0E1B\u0E23\u0E14\u0E28\u0E36\u0E01\u0E29\u0E32\u0E1B\u0E23\u0E30\u0E01\u0E32\u0E28\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48",
      backgroundImage: "/images/privacy-policy/privacy-policy-page-header.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: "relative w-screen h-fit py-16",
      style: {
        minHeight: '50vh'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
        className: "Container",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: "flex flex-col space-y-10 lg:ml-12 lg:mb-32",
          children: contents.map(function (content) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
              href: content.fileUrl,
              passHref: true,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("a", {
                target: "_blank",
                className: "flex flex-row justify-start items-center p-5 space-x-5 rounded-md hover:cursor-pointer hover:bg-slate-100 lg:max-w-[55%]",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                  className: "",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                    src: "/images/privacy-policy/privacy-policy-file-icon.png",
                    alt: content.fileUrl,
                    width: 59,
                    height: 59,
                    layout: "fixed"
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                  className: "flex flex-col space-y-3",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h2", {
                    className: "text-p2Regular font-medium text-lightBlue underline",
                    children: content.topic
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                    className: "text-p4Regular text-gray-600",
                    children: content.detail
                  })]
                })]
              })
            }, content.id);
          })
        })
      })
    })]
  });
};

PrivacyPolicyPage.getLayout = function (page) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_0__/* .Layout */ .A, {
    children: page
  });
};

/* harmony default export */ __webpack_exports__["default"] = (PrivacyPolicyPage);
var contents = [{
  id: 1,
  topic: 'ลูกค้า และบุคคลทั่วไป',
  detail: 'ประกาศความเป็นส่วนตัวสำหรับลูกค้า และบุคคลทั่วไปของบริษัทฯ หรือมีความเกี่ยวข้องกับบริษัทฯ ของ บริษัท โคเดียม จำกัด',
  fileUrl: models_conent__WEBPACK_IMPORTED_MODULE_6__/* .strapi */ .s1 + '/uploads/Privacy_notice_Customer_CODIUM_25_07_2022_pdf_1_74aad20caa.pdf'
}, {
  id: 2,
  topic: 'พนักงาน กรรมการบริษัทฯ ',
  detail: 'ประกาศความเป็นส่วนตัวของบริษัท โคเดียม จำกัด สำหรับพนักงาน กรรมการบริษัทฯ ผู้บริหารระดับสูง ผู้ถือหุ้นของบริษัทฯ สมาชิกในครอบครัวของพนักงาน หรือบุคคลใดที่พนักงานได้ให้ข้อมูลไว้',
  fileUrl: models_conent__WEBPACK_IMPORTED_MODULE_6__/* .strapi */ .s1 + '/uploads/Privacy_notice_Employee_CODIUM_25_07_2022_docx_8235ec1d90.pdf'
}, {
  id: 3,
  topic: 'ผู้สมัครงาน ',
  detail: 'ประกาศความเป็นส่วนตัวของบริษัท โคเดียม จำกัด สำหรับผู้สมัครงาน สมาชิกในครอบครัวของผู้สมัครงาน หรือบุคคลใดที่ผู้สมัครงานได้ให้ข้อมูลไว้',
  fileUrl: models_conent__WEBPACK_IMPORTED_MODULE_6__/* .strapi */ .s1 + '/uploads/Privacy_notice_Candidate_CODIUM_25_07_2022_docx_2_a4b3695eca.pdf'
}, {
  id: 4,
  topic: 'ผู้มีความสัมพันธ์ทางธุรกิจ',
  detail: 'ประกาศความเป็นส่วนตัวสำหรับผู้ที่มีความสัมพันธ์ทางธุรกิจของ บริษัท โคเดียม จำกัด',
  fileUrl: models_conent__WEBPACK_IMPORTED_MODULE_6__/* .strapi */ .s1 + '/uploads/Privacy_notice_business_Partnership_CODIUM_09_08_2022_64c5d6fe30.pdf'
}];

/***/ }),

/***/ 4217:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(7180);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [735,467,60,774,888,179], function() { return __webpack_exec__(4217); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);